/**
 * Bootstrap Entry Point
 *
 * This file is the entry point for the Admin application.
 * It uses dynamic import to ensure the MUI ClassNameGenerator is configured
 * BEFORE any MUI components are loaded (avoiding ES module hoisting issues).
 *
 * Load order:
 * 1. dpl/config - Configures MUI class name prefix (Wilson-*)
 * 2. index.ts - Main application (loaded dynamically after config completes)
 *
 * This ensures DPL theme styles (.Wilson-Mui*) match the actual class names.
 */

// Configure MUI class names first - this is the ONLY static import
import 'dpl/config'

// Dynamically import the main app AFTER config is complete
import('./index')
